import React from "react";
import clsx from 'clsx';
import RoomTypeBuilderErrors from "../RoomTypeBuilderErrors";
import NumberSpinner from "../../NumberSpinner/NumberSpinner";
import I18n from "i18n-js";
import ErrorHelper from "../../Errors/ErrorHelper";
import RateSelect from "../../Selects/RateSelect";

class RoomTypeBuilderChannelManagement extends React.Component {

  constructor(props) {
    super(props)
  }


  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'channel_management',
      'tab-pane': true
    });

    return (
      <div className={tabClasses} id="channel_management">
        {this.renderErrors()}
        <div className="row">
          <div className="col-md-12">
            {this.renderGeneralForm()}
          </div>
        </div>
      </div>
    )
  }

  renderErrors() {
    var errors = RoomTypeBuilderErrors.channels(this.props.errors);

    if (errors && errors.length) {
      var idx = 0;
      var errors = errors.map((error) => {
        idx = idx + 1;
        return <li key={error + idx}>{error}</li>
      });

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  renderFieldErrors(field) {
    if (this.props.errors && this.props.errors[field]) {
      var idx = 0;
      var errors = this.props.errors[field].map((error) => {
        if (error == "must be greater than 0") {
          idx = idx + 1;
          return <li style={{ textAlign: "left" }} key={idx}><b>&#x2022;</b> {error}</li>;
        } else if (error == "is not a number") {
          idx = idx + 1;
          return <li style={{ textAlign: "left" }} key={idx}><b>&#x2022;</b> {error}</li>;
        } else {
          idx = idx + 1;
          return <li key={idx}><b>&#x2022;</b> {error}</li>;
        }
      });
      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      )
    }
  }

  renderFieldClasses(field, noFormControl) {
    if (noFormControl === true) {
      var classname = ''
    } else {
      var classname = 'form-control';
    }
    if (this.props.errors && Object.keys(this.props.errors).length && this.props.errors[field]) {
      classname = classname + ' has-errors';
    }
    return classname;
  }

  renderGeneralForm() {
    return (
      <div>

        <div className="row">
          {this.renderOtaPropertyTypes()}

          <div className="col-md-2">
            <div className="form-group">
              <label>{I18n.t('rate')}* <span className="ss-help help" title={I18n.t('room_type_builder_channel_rate_helper_text')}></span></label>
              <RateSelect
                name="rate"
                hasError={this.renderFieldClasses("channel_rate")}
                selectID={this.props.ru_rate ? this.props.ru_rate.id : null}
                rate={this.props.ru_rate ? this.props.ru_rate : null}
                onChange={this.onChangeRuRate}
                remote_path={this.props.ru_rates_path}
                ruRate={true}
              />
              {this.renderFieldErrors("channel_rate")}
            </div>
          </div>

          <div className="col-md-2">

            <div className="form-group">
              <label>{I18n.t("bedroom_count")}*</label>
              <select
                name="property_type_id"
                value={this.props.property_type_id || ""}
                className={this.renderFieldClasses("property_type")}
                onChange={this.props.onChangePropertyType}
              >
                <option value="" disabled>{I18n.t("select_ellipsis")}</option>
                {this.props.all_property_types.map((property_type) => {
                  return (
                    <option key={property_type.id} value={property_type.id}>
                      {property_type.description}
                    </option>
                  );
                })}
              </select>
              {this.renderFieldErrors("property_type")}
            </div>
          </div>

          <div className="col-md-2">
            <div className="form-group">
              <label>{I18n.t('bathrooms_count')}*</label>
              <NumberSpinner
                id="bathroom_count"
                name="room_type[bathroom_count]"
                value={this.props.bathroom_count || ''}
                onChange={this.props.onFieldChange}
                hasError={this.renderFieldClasses("bathroom_count")}
              />
              {this.renderFieldErrors("bathroom_count")}
            </div>
          </div>

          {/* <div className="col-md-2">
            <div className="form-group">
              <label>{I18n.t('floor')} <span className="ss-help help" title={I18n.t('room_type_floor_helper_text')}></span></label>
              <NumberSpinner
                id="floor"
                name="room_type[floor]"
                value={this.props.floor || ''}
                onChange={this.props.onFieldChange}
                hasError={this.renderFieldClasses("floor")}
              />
              {this.renderFieldErrors("floor")}
            </div>
          </div> */}


          <div className="col-md-2">
            <div className="form-group">
              <label>{I18n.t('days_before_arrival')} <span className="ss-help help" title={I18n.t('days_before_arrival_helper_text')}></span></label>
              <NumberSpinner
                id="days_before_arrival"
                name="room_type[days_before_arrival]"
                value={this.props.days_before_arrival || ''}
                onChange={this.props.onFieldChange}
              />
            </div>
          </div>

        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{I18n.t('ota_description')}*</label>
              <textarea name="room_type[ru_description]" id="ru_description" className={ErrorHelper.renderFieldClasses('ru_description', this.props.errors, 'form-control')} rows={4} value={this.props.ru_description || ''} onChange={this.props.onFieldChange} />
              {ErrorHelper.renderFieldErrors('ru_description', this.props.errors)}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{I18n.t('how_to_arrive')} <span className="ss-help help" title={I18n.t('how_to_arrive_helper_text')}></span></label>
              <textarea name="room_type[how_to_arrive]" id="how_to_arrive" className={ErrorHelper.renderFieldClasses('how_to_arrive', this.props.errors, 'form-control')} rows={4} value={this.props.how_to_arrive || ''} onChange={this.props.onFieldChange} />
              {ErrorHelper.renderFieldErrors('how_to_arrive', this.props.errors)}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{I18n.t('access')} <span className="ss-help help" title={I18n.t('access_helper_text')}></span></label>
              <textarea name="room_type[access]" id="access" className={ErrorHelper.renderFieldClasses('access', this.props.errors, 'form-control')} rows={4} value={this.props.access || ''} onChange={this.props.onFieldChange} />
              {ErrorHelper.renderFieldErrors('access', this.props.errors)}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{I18n.t('interaction')} <span className="ss-help help" title={I18n.t('interaction_helper_text')}></span></label>
              <textarea name="room_type[interaction]" id="interaction" className={ErrorHelper.renderFieldClasses('interaction', this.props.errors, 'form-control')} rows={4} value={this.props.interaction || ''} onChange={this.props.onFieldChange} />
              {ErrorHelper.renderFieldErrors('interaction', this.props.errors)}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{I18n.t('house_rules')} <span className="ss-help help" title={I18n.t('house_rules_helper_text')}></span></label>
              <textarea name="room_type[house_rules]" id="house_rules" className={ErrorHelper.renderFieldClasses('house_rules', this.props.errors, 'form-control')} rows={4} value={this.props.house_rules || ''} onChange={this.props.onFieldChange} />
              {ErrorHelper.renderFieldErrors('access', this.props.errors)}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{I18n.t('space')} <span className="ss-help help" title={I18n.t('space_helper_text')}></span></label>
              <textarea name="room_type[space]" id="space" className={ErrorHelper.renderFieldClasses('space', this.props.errors, 'form-control')} rows={4} value={this.props.space || ''} onChange={this.props.onFieldChange} />
              {ErrorHelper.renderFieldErrors('space', this.props.errors)}
            </div>
          </div>
        </div>

      </div>
    );
  };

  renderOtaPropertyTypes = () => {
    const options = this.props.ota_property_types.map(otaPropertyType => <option key={otaPropertyType.id} value={otaPropertyType.id}>{I18n.t(otaPropertyType.description)}</option>)
    return (
      <div className="col-md-2">
        <div className="form-group">
          <label>{I18n.t('ota_property_type')}*</label>
          <select
            name="ota_property_type"
            value={this.props.ota_property_type}
            className={this.renderFieldClasses("property_type")}
            onChange={this.props.onChange}
          >
            <option value="" disabled>{I18n.t("select_ellipsis")}</option>
            {options}
          </select>
          {this.renderFieldErrors("ota_property_type")}
        </div>
      </div>
    );
  };

  onChangeRuRate = (rate) => {
    this.props.onChange({ target: { name: 'ru_rate', value: rate } });
  };

};

export default RoomTypeBuilderChannelManagement